import { Input } from "@/components/ui/input";


export default function XeroEntityCell({
  draft,
  tenantName,
  isPending,
  onDraftChange,
}: {
  draft: string;
  tenantName: string;
  isPending: boolean;
  onDraftChange: (next: string) => void;
}) {
  return (
    <Input
      value={draft}
      onChange={(e) => onDraftChange(e.target.value)}
      disabled={isPending}
      maxLength={200}
      className="h-8"
      placeholder="Add an entity"
      aria-label={`Entity for ${tenantName}`}
    />
  );
}
